import { default as SmppProvider } from './SmppProvider';

export { SmppProvider };



// WEBPACK FOOTER //
// src/modules/screens/settings/SmppProvider/components/index.js